<template>
    <div id="editInvoice">
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
          <loading :active.sync="isLoading" 
                :can-cancel="true" 
                :is-full-page="fullPage"></loading>
            <flash-message class="myCustomClass"></flash-message>
            <h5 class="modal-title" id="exampleModalLabel">Edit Invoice</h5>
            <button type="button" class="close" @click="$emit('close')" id="editinvoiceClose" data-dismiss="modal" aria-label="Close">
              <i class="material-icons">close</i>
            </button>
          </div>
          <form>
            <div class="modal-body">
            <p style="color:red;text-align:center">{{ errorMessage }}</p>
              <p v-if="errors.length">
                <p style='color:red;text-align:center' v-for="error in errors"> {{ error }}</p>
              </p>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <select class="form-control" ref="brand_id" id="brand_id" name="brand_id" v-model="invoiceDetails.InvoiceData.brand_id" @change="changeBrand($event)" v-if="invoiceDetails.InvoiceData.status === 'open'" disabled>
                      <option value="">select brand</option>
                      <option v-for="(brand, index, key) in getBrandsAscendingOrder" :value="index">{{ brand.brand_name }}</option>
                    </select>
                    <select class="form-control" ref="brand_id" id="brand_id" name="brand_id" v-model="invoiceDetails.InvoiceData.brand_id" @change="changeBrand($event)" v-if="invoiceDetails.InvoiceData.status === 'paid'" disabled>
                      <option value="">select brand</option>
                      <option v-for="(brand, index, key) in getBrandsAscendingOrder" :value="index">{{ brand.brand_name }}</option>
                    </select>
                    <select class="form-control" ref="brand_id" id="brand_id" name="brand_id" v-model="invoiceDetails.InvoiceData.brand_id" @change="changeBrand($event)" v-if="invoiceDetails.InvoiceData.status === 'draft'">
                      <option value="">select brand</option>
                      <option v-for="(brand, index, key) in getBrandsAscendingOrder" :value="index">{{ brand.brand_name }}</option>
                    </select>
                  </div>
                  <!-- <div class="custom-control custom-checkbox form-group">
                      <input type="checkbox" class="custom-control-input" id="termsandcond" v-on:click="checkboxClick()" v-if="invoiceDetails.InvoiceData.status === 'open' && invoiceDetails.InvoiceData.escrow === true"  disabled checked>
                      <input type="checkbox" class="custom-control-input" id="termsandcond" v-on:click="checkboxClick()" v-if="invoiceDetails.InvoiceData.status === 'paid' && invoiceDetails.InvoiceData.escrow === true"  disabled checked>
                      <input type="checkbox" class="custom-control-input" id="termsandcond" v-on:click="checkboxClick()" v-if="invoiceDetails.InvoiceData.status === 'draft' && invoiceDetails.InvoiceData.escrow === true" checked>
                      <label class="custom-control-label" for="termsandcond">Escrow</label>
                  </div> -->
                  <div class="form-group" id="hidedays">
                    <select class="form-control" ref="duedays" id="duedays" name="duedays" v-model="invoiceDetails.InvoiceData.due_days" @change="editchangeDays($event)" v-if="invoiceDetails.InvoiceData.status === 'open'" disabled>
                      <option value="" selected>Payment Term*</option>
                      <option value="1">Escrow</option>
                      <option value="15">15 days </option>
                      <option value="30">30 days </option>
                      <option value="45">45 days </option>
                      <option value="60">60 days </option>
                    </select>
                    <select class="form-control" ref="duedays" id="duedays" name="duedays" v-model="invoiceDetails.InvoiceData.due_days" @change="editchangeDays($event)" v-if="invoiceDetails.InvoiceData.status === 'paid'" disabled>
                      <option value="" selected>Payment Term*</option>
                      <option value="1">Escrow</option>
                      <option value="15">15 days </option>
                      <option value="30">30 days </option>
                      <option value="45">45 days </option>
                      <option value="60">60 days </option>
                    </select>
                    <select class="form-control" ref="duedays" id="duedays" name="duedays" v-model="invoiceDetails.InvoiceData.due_days" @change="editchangeDays($event)" v-if="invoiceDetails.InvoiceData.status === 'draft'">
                      <option value="" selected>Payment Term*</option>
                      <option value="1">Escrow</option>
                      <option value="15">15 days </option>
                      <option value="30">30 days </option>
                      <option value="45">45 days </option>
                      <option value="60">60 days </option>
                    </select>
                  </div>
                  <div class="form-group" id="" >
                    <select class="form-control" ref="invoice_type" id="invoice_type" name="invoice_type" v-model="invoiceDetails.InvoiceData.invoice_type"  v-if="invoiceDetails.InvoiceData.status === 'open'" disabled>
                      <option value="">Invoice Type*</option>
                      <option value="immediate">Immediate</option>
                      <option value="held">Held</option>
                    </select>
                    <select class="form-control" ref="invoice_type" id="invoice_type" name="invoice_type" v-model="invoiceDetails.InvoiceData.invoice_type"  v-if="invoiceDetails.InvoiceData.status === 'paid'" disabled>
                      <option value="">Invoice Type*</option>
                      <option value="immediate">Immediate</option>
                      <option value="held">Held</option>
                    </select>
     
                    <select class="form-control" ref="invoice_type" id="invoice_type" name="invoice_type" v-model="invoiceDetails.InvoiceData.invoice_type"  v-if="invoiceDetails.InvoiceData.status === 'draft'">
                      <option value="">Invoice Type*</option>
                      <option value="immediate">Immediate</option>
                      <option value="held">Held</option>
                    </select>
                  </div>
                  <div v-for="(brand, index, key) in brands">
                   <div class="brand-detail" v-if="index === selectedBrand || index === invoiceDetails.InvoiceData.brand_id">
                      <div class="brand-logo">
                        <img v-bind:src="brand.brand_logo" >
                      </div>
                      <ul>
                        <li>
                          <i class="material-icons">language</i>
                          <span> {{brand.brand_name}}</span>
                        </li>
                        <li>
                          <i class="material-icons">mail</i>
                          <span> {{brand.site_url}}</span>
                        </li>
                        <li>
                          <i class="material-icons">phone</i>
                          <span> {{brand.contact_no}}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <input type="text" ref="amount" class="form-control" id="amount" name="amount" v-model="invoiceDetails.InvoiceData.amount" placeholder="Enter Amount" v-if="invoiceDetails.InvoiceData.status === 'open'" disabled/>
                    <input type="text" ref="amount" class="form-control" id="amount" name="amount" v-model="invoiceDetails.InvoiceData.amount" placeholder="Enter Amount" v-if="invoiceDetails.InvoiceData.status === 'paid' " disabled/>
                    <input type="text" ref="amount" class="form-control" id="amount" name="amount" v-model="invoiceDetails.InvoiceData.amount" placeholder="Enter Amount" v-if="invoiceDetails.InvoiceData.status === 'draft'"/>
                    <input type="hidden" class="form-control" name="uid" v-model="invoiceDetails.InvoiceData.uid" placeholder="Invoice Id" />
                    <input type="hidden" class="form-control" name="puid" v-model="invoiceDetails.InvoiceData.invoice_percentage_id" placeholder="Invoice Percentage Id" />
                  </div>
                  <div class="form-group">
                    <textarea class="form-control" ref="description" id="description" name="description" v-model="invoiceDetails.InvoiceData.description" placeholder="Description" v-if="invoiceDetails.InvoiceData.status === 'open'" disabled>
                    </textarea>
                    <textarea class="form-control" ref="description" id="description" name="description" v-model="invoiceDetails.InvoiceData.description" placeholder="Description" v-if="invoiceDetails.InvoiceData.status === 'paid' " disabled>
                    </textarea>
                    <textarea class="form-control" ref="description" id="description" name="description" v-model="invoiceDetails.InvoiceData.description" placeholder="Description" v-if="invoiceDetails.InvoiceData.status === 'draft'">
                    </textarea>
                  </div>
                  <div class="row">
                    <div class="col-md-7">
                      <div class="form-group">
                        <!-- <span style="float:right;margin-top:10px">Escrow</span> -->
                        <select class="form-control" ref="admin" id="admin" name="admin" v-model="invoiceDetails.invoicePercentageData.escrowUser_id" @change="changeAdmin($event)" v-if="invoiceDetails.InvoiceData.status === 'open'" disabled>
                          <option value="">Select Escrow</option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.user_type === 'escrow' && user.role === 'user' && user.status === 'active' && user.platform_payments === 'active'">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select>
                        <select class="form-control" ref="admin" id="admin" name="admin" v-model="invoiceDetails.invoicePercentageData.escrowUser_id" @change="changeAdmin($event)" v-if="invoiceDetails.InvoiceData.status === 'paid' " disabled>
                          <option value="">Select Escrow</option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.user_type === 'escrow' && user.status === 'active' && user.platform_payments === 'active'">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select>
                        <select class="form-control" ref="admin" id="admin" name="admin" v-model="invoiceDetails.invoicePercentageData.escrowUser_id" @change="changeAdmin($event)" v-if="invoiceDetails.InvoiceData.status === 'draft'">
                          <option value="">Select Escrow</option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.user_type === 'escrow' && user.status === 'active' && user.platform_payments === 'active'">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select> 
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="form-group">
                        <input type="number" ref="admin_percentage" class="form-control" id="admin_percentage" name="admin_percentage" v-model="invoiceDetails.invoicePercentageData.escrowUser_percentage" placeholder="00.00%" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-7">
                      <div class="form-group">
                        <select class="form-control" ref="userA" id="userA" name="userA" v-model="invoiceDetails.invoicePercentageData.userA_id" @change="changeUserFirst($event)" v-if="invoiceDetails.InvoiceData.status === 'open'" disabled>
                          <option value="">User A</option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.role === 'user' && user.status === 'active' && user.user_type === 'user' && user.platform_payments === 'active'">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select>
                        <select class="form-control" ref="userA" id="userA" name="userA" v-model="invoiceDetails.invoicePercentageData.userA_id" @change="changeUserFirst($event)" v-if="invoiceDetails.InvoiceData.status === 'paid' " disabled>
                          <option value="">User A</option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.role === 'user' && user.status === 'active' &&  user.user_type === 'user' && user.platform_payments === 'active'">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select>
                        <select class="form-control" ref="userA" id="userA" name="userA" v-model="invoiceDetails.invoicePercentageData.userA_id" @change="changeUserFirst($event)" v-if="invoiceDetails.InvoiceData.status === 'draft'">
                          <option value="">User A</option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.role === 'user' && user.status === 'active' && user.user_type === 'user' && user.platform_payments === 'active'">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="form-group">
                        <input type="number" class="form-control" ref="userA_percentage" id="userA_percentage" name="userA_percentage" v-model="invoiceDetails.invoicePercentageData.userA_percentage" placeholder="00.00%" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-7">
                      <div class="form-group">
                        <select class="form-control" ref="userB" id="userB" name="userB" v-model="invoiceDetails.invoicePercentageData.userB_id" @change="changeUserSecond($event)" v-if="invoiceDetails.InvoiceData.status === 'open'" disabled>
                          <option value="">User B </option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.role === 'user' && user.status === 'active' && user.user_type === 'user' && user.platform_payments === 'active' && user.uid !== selecteduserA ">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select>
                        <select class="form-control" ref="userB" id="userB" name="userB" v-model="invoiceDetails.invoicePercentageData.userB_id" @change="changeUserSecond($event)" v-if="invoiceDetails.InvoiceData.status === 'paid'" disabled>
                          <option value="">User B </option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.role === 'user' && user.status === 'active' && user.user_type === 'user' && user.platform_payments === 'active' && user.uid !== selecteduserA ">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select>
                        <select class="form-control" ref="userB" id="userB" name="userB" v-model="invoiceDetails.invoicePercentageData.userB_id" @change="changeUserSecond($event)" v-if="invoiceDetails.InvoiceData.status === 'draft'">
                          <option value="">User B </option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.role === 'user' && user.status === 'active' && user.user_type === 'user' &&  user.platform_payments === 'active' && user.uid !== selecteduserA ">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="form-group">
                        <input type="number" class="form-control" ref="userB_percentage" id="userB_percentage" name="userB_percentage" v-model="invoiceDetails.invoicePercentageData.userB_percentage" placeholder="00.00%" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-7">
                      <div class="form-group">
                        <select class="form-control" ref="userC" id="userC" name="userC" v-model="invoiceDetails.invoicePercentageData.userC_id" @change="changeUserThird($event)" v-if="invoiceDetails.InvoiceData.status === 'open'" disabled>
                          <option value="">User C </option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.role === 'user' && user.status === 'active' && user.user_type === 'user' && user.platform_payments === 'active' && user.uid !== selecteduserA && user.uid !== selecteduserB ">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select>
                        <select class="form-control" ref="userC" id="userC" name="userC" v-model="invoiceDetails.invoicePercentageData.userC_id" @change="changeUserThird($event)" v-if="invoiceDetails.InvoiceData.status === 'paid'" disabled>
                          <option value="">User C </option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.role === 'user' && user.status === 'active' && user.user_type === 'user' && user.platform_payments === 'active' && user.uid !== selecteduserA && user.uid !== selecteduserB ">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select>
                        <select class="form-control" ref="userC" id="userC" name="userC" v-model="invoiceDetails.invoicePercentageData.userC_id" @change="changeUserThird($event)" v-if="invoiceDetails.InvoiceData.status === 'draft'">
                          <option value="">User C </option>
                          <option v-for="(user, index, key) in users" :value="user.uid" v-if="user.role === 'user' && user.status === 'active' && user.user_type === 'user' &&  user.platform_payments === 'active' && user.uid !== selecteduserA && user.uid !== selecteduserB ">{{ user.firstname }} {{ user.lastname }} <{{ user.email }}></option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-5">
                      <div class="form-group">
                        <input type="number" class="form-control" ref="userC_percentage" id="userC_percentage" name="userC_percentage" v-model="invoiceDetails.invoicePercentageData.userC_percentage" placeholder="00.00%" />
                      </div>
                    </div>
                  </div>
                  <i>The total Split (%) should add up to 100% (Mandatory)</i>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" id="editdraft" data-dismiss="modal" v-on:click="editdraftInvoice()" v-if="invoiceDetails.InvoiceData.status === 'draft'">Save as Draft</button>
              <button type="button" class="btn btn-primary" id="editsave" v-on:click="editsaveInvoice()">Save and Send</button>
            </div>
          </form>
        </div>
      </div>
    </div>
</template>
<script>
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
export default {
  name: 'EditInvoiceModal',
  props: ['invoiceDetails'],
  components: {
    Loading
  },
  data () {
    return {
      isLoading: false,
      fullPage: true,
      errorMessage: '',
      date: '2019-10-01 00:00:00',
      invoicesList: [],
      invoices: [],
      realtime: '',
      brands: [],
      users: [],
      invoiceDatas: [],
      invoicePartiesPercentageDatas: [],
      getBrandsAscendingOrder: [],
      BrandDatas: [],
      errors: [],
      i: 0,
      input: {
        brandid: '',
        amount: '',
        admin: '',
        description: '',
        adminpercent: '',
        userA: '',
        userApercent: '',
        userB: '',
        userBpercent: '',
        userC: '',
        userCpercent: '',
        duedays: ''
      },
      selectedBrand: '',
      selecteduserA: '',
      selecteduserB: '',
      selecteduserC: '',
      selectedDays: '',
      statusInvoice: ''
    }
  },
  methods: {
    changeBrand (event) {
      this.selectedBrand = event.target.options[event.target.options.selectedIndex].value
      console.log(this.selectedBrand)
    },
    changeUserFirst () {
      this.selecteduserA = event.target.options[event.target.options.selectedIndex].value
      // alert(this.selecteduserA)
      if (this.selecteduserA === '')
      {
        this.invoiceDetails.invoicePercentageData.userA_percentage = ''
        this.invoiceDetails.invoicePercentageData.userB_percentage = ''
        this.invoiceDetails.invoicePercentageData.userC_percentage = ''
        var x = document.getElementById("userB");
        x.remove(x.selectedIndex);
        var y = document.getElementById("userC");
        y.remove(y.selectedIndex);
        document.getElementById('userB').disabled = true
        document.getElementById('userC').disabled = true
        
        document.getElementById('userA_percentage').disabled = true
        document.getElementById('userB_percentage').disabled = true
        document.getElementById('userC_percentage').disabled = true
      } else {
        document.getElementById('userB').disabled = false  
        document.getElementById('userA_percentage').disabled = false   
      }
    },
    changeUserSecond () {
      this.selecteduserB = event.target.options[event.target.options.selectedIndex].value
      if (this.selecteduserB === '')
      {
        this.invoiceDetails.invoicePercentageData.userC_percentage = ''
        document.getElementById('userB_percentage').disabled = true
        document.getElementById('userC_percentage').disabled = true
        var z = document.getElementById("userC");
        z.remove(z.selectedIndex);
        document.getElementById('userC').disabled = true
      } else {
        
        document.getElementById('userC').disabled = false
        document.getElementById('userB_percentage').disabled = false   
      }
    },
    changeUserThird () {
      this.selecteduserC = event.target.options[event.target.options.selectedIndex].value
      if (this.selecteduserC === '')
      {
        this.invoiceDetails.invoicePercentageData.userC_percentage = ''
        document.getElementById('userC_percentage').disabled = true
      } else {
        document.getElementById('userC_percentage').disabled = false   
      }
    },
    getBrands () {
      var jwttoken = localStorage.getItem('jwt')
      this.isLoading = true
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllBrands', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.brands = response.data.results
          console.log(this.brands)
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    },
    getUsers () {
      this.isLoading = true
      var jwttoken = localStorage.getItem('jwt')
      axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getAllUsers', {
        headers: {
          'x-access-token': jwttoken
        }})
        .then(response => {
          this.isLoading = false
          this.users = response.data.results
          console.log(this.users)
        })
        .catch((error) => {
          this.errorMessage = error.response.data.errors
          this.isLoading = false
        })
    },
    editchangeDays (event) {
       let optionList= document.getElementById("invoice_type");
       let display = "block"
       let selected = ""
      if (this.invoiceDetails.InvoiceData.due_days === '1') {
             display = "none"
             selected="true"
      }
      for (let i = 0; i < optionList.length; i++) {
                  if (optionList.options[i].value === 'immediate') {
                      optionList.options[i].style.display = display
                   } 
                   if (optionList.options[i].value === 'held') {
                    this.invoiceDetails.InvoiceData.invoice_type = 'held'
                      optionList.options[i].selected=selected
                   } 
              } 

    },
    editsaveInvoice () {
      var jwttoken = localStorage.getItem('jwt')
      this.errors = []
      var status = 'open'
      var amount = parseFloat(this.invoiceDetails.InvoiceData.amount)
      var description = this.invoiceDetails.InvoiceData.description
      var uid = this.invoiceDetails.InvoiceData.uid
      var puid = this.invoiceDetails.InvoiceData.invoice_percentage_id
      var adminpercent = this.invoiceDetails.invoicePercentageData.escrowUser_percentage
      var userApercent = this.invoiceDetails.invoicePercentageData.userA_percentage
      var userBpercent = this.invoiceDetails.invoicePercentageData.userB_percentage ? this.invoiceDetails.invoicePercentageData.userB_percentage : 0
      var userCpercent = this.invoiceDetails.invoicePercentageData.userC_percentage ? this.invoiceDetails.invoicePercentageData.userC_percentage : 0
      var brandId = this.invoiceDetails.InvoiceData.brand_id
      
      var adminId = this.invoiceDetails.invoicePercentageData.escrowUser_id
      var userA = this.invoiceDetails.invoicePercentageData.userA_id
      var userB = this.invoiceDetails.invoicePercentageData.userB_id
      var userC = this.invoiceDetails.invoicePercentageData.userC_id
      var duedays = this.invoiceDetails.InvoiceData.due_days
      var scheduledate = this.invoiceDetails.InvoiceData.schedule_date
      var invoiceType = this.invoiceDetails.InvoiceData.invoice_type
      
      var total = parseFloat(adminpercent) + parseFloat(userApercent) + parseFloat(userBpercent) + parseFloat(userCpercent)
      if (brandId === '') {
        this.errors.push('Brand is Required')
        this.$refs.brand_id.focus()
      } else if (invoiceType === '') {
        this.errors.push('Invoice Type is Required')
        this.$refs.invoice_type.focus()
      } else if (duedays === '') {
        this.errors.push('Due Days is Required')
        this.$refs.duedays.focus()
      } else if (amount === '') {
        this.errors.push('Amount is Required')
        this.$refs.amount.focus()
      } else if (!/^\d+(\.\d+)?$/.test(amount)) {
        this.errors.push('Enter Valid Number')
        this.$refs.amount.focus()
      } else if (description === '') {
        this.errors.push('Descrition is Required')
        this.$refs.description.focus()
      } else if (adminId === '') {
        this.errors.push('Admin is Required')
        this.$refs.admin.focus()
      } else if (adminpercent === '') {
        this.errors.push('Admin percentage is Required')
        this.$refs.admin_percentage.focus()
      } else if (userA === '') {
        this.errors.push('UserA is Required')
        this.$refs.userA.focus()
      } else if (userApercent === '') {
        this.errors.push('userA percentage is Required')
        this.$refs.userA_percentage.focus()
      } else if (total !== 100) {
        this.errors.push('Total should be 100')
      } else {
        this.isLoading = true
        axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/editInvoice', {
          brand_id: brandId,
          amount: amount,
          description: description,
          escrowUser_id: adminId,
          escrowUser_percentage: adminpercent,
          userA_id: userA,
          userA_percentage: userApercent,
          userB_id: userB,
          userB_percentage: userBpercent,
          userC_id: userC,
          userC_percentage: userCpercent,
          status: status,
          uid: uid,
          puid: puid,
          due_days: duedays,
          schedule_date: scheduledate,
          escrow: '',
          invoice_type: invoiceType
        }, {
          headers: {
            'x-access-token': jwttoken
          }})
         .then(response => {
            this.isLoading = false
            this.$eventBus.$emit('listInvoice', 'Invoice is Updated successfully');
            this.$eventBus.$emit('latestDashbordList');
            this.$emit('close')
           })
            .catch((error) => {
              this.$eventBus.$emit('listInvoice', '','Invoice could not be Updated');
              this.$emit('close')
              this.errorMessage = error.response.data.errors
              this.isLoading = false
            })
      }
    },
    editdraftInvoice () {
      var jwttoken = localStorage.getItem('jwt')
      this.errors = []
      var status = 'draft'
      var amount = parseFloat(this.invoiceDetails.InvoiceData.amount)
      var description = this.invoiceDetails.InvoiceData.description
      var uid = this.invoiceDetails.InvoiceData.uid
      var puid = this.invoiceDetails.InvoiceData.invoice_percentage_id
      var adminpercent = this.invoiceDetails.invoicePercentageData.escrowUser_percentage
      var userApercent = this.invoiceDetails.invoicePercentageData.userA_percentage
      var userBpercent = this.invoiceDetails.invoicePercentageData.userB_percentage ? this.invoiceDetails.invoicePercentageData.userB_percentage : 0
      var userCpercent = this.invoiceDetails.invoicePercentageData.userC_percentage ? this.invoiceDetails.invoicePercentageData.userC_percentage : 0
      var brandId = this.invoiceDetails.InvoiceData.brand_id
      var adminId = this.invoiceDetails.invoicePercentageData.escrowUser_id
      var userA = this.invoiceDetails.invoicePercentageData.userA_id
      var userB = this.invoiceDetails.invoicePercentageData.userB_id
      var userC = this.invoiceDetails.invoicePercentageData.userC_id
      var invoiceType = this.invoiceDetails.InvoiceData.invoice_type
      var total = parseFloat(adminpercent) + parseFloat(userApercent) + parseFloat(userBpercent) + parseFloat(userCpercent)
      var scheduledate = this.invoiceDetails.InvoiceData.schedule_date
      var duedays = this.invoiceDetails.InvoiceData.due_days
      
      if (brandId === '') {
        this.errors.push('Brand is Required')
        this.$refs.brand_id.focus()
      } else if (invoiceType === '') {
        this.errors.push('Invoice Type is Required')
        this.$refs.invoice_type.focus()
      } else if (duedays === '') {
        this.errors.push('Due Days is Required')
        this.$refs.duedays.focus()
      } else if (amount === '') {
        this.errors.push('Amount is Required')
        this.$refs.amount.focus()
      } else if (!/^\d+(\.\d+)?$/.test(amount)) {
        this.errors.push('Enter Valid Number')
        this.$refs.amount.focus()
      } else if (description === '') {
        this.errors.push('Description is Required')
        this.$refs.description.focus()
      } else if (adminId === '') {
        this.errors.push('Admin is Required')
        this.$refs.admin.focus()
      } else if (adminpercent === '') {
        this.errors.push('Admin percentage is Required')
        this.$refs.admin_percentage.focus()
      } else if (userA === '') {
        this.errors.push('UserA is Required')
        this.$refs.userA.focus()
      } else if (userApercent === '') {
        this.errors.push('userA percentage is Required')
        this.$refs.userA_percentage.focus()
      } else if (total !== 100) {
        this.errors.push('Total should be 100')
      } else {
        this.isLoading = true
        axios.post('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/editInvoice', {
          brand_id: brandId,
          amount: amount,
          description: description,
          escrowUser_id: adminId,
          escrowUser_percentage: adminpercent,
          userA_id: userA,
          userA_percentage: userApercent,
          userB_id: userB,
          userB_percentage: userBpercent,
          userC_id: userC,
          userC_percentage: userCpercent,
          status: status,
          uid: uid,
          puid: puid,
          schedule_date: scheduledate,
          due_days: duedays,
          invoice_type: invoiceType,
          escrow: '',
        }, {
          headers: {
            'x-access-token': jwttoken
          }})
          .then(response => {
            this.isLoading = false
            this.$eventBus.$emit('listInvoice', 'Invoice is Updated successfully');
            this.$eventBus.$emit('latestDashbordList');
            this.$emit('close')
           })
            .catch((error) => {
              this.$eventBus.$emit('listInvoice', '','Invoice could not be Updated');
              this.$emit('close')
              this.errorMessage = error.response.data.errors
              this.isLoading = false
            })
      }
    }
  },
  created () {
    this.getBrands()
    this.getUsers()
    // this.getInvoice()
  },
  mounted () {
  var jwttoken = localStorage.getItem('jwt')
    axios.get('https://us-central1-stripe-firebase-133c0.cloudfunctions.net/getListBrands', {
        headers: {
          'x-access-token': jwttoken
    }})
    .then(response => {
      this.isLoading = false
      this.getBrandsAscendingOrder = response.data.results
      console.log(this.getBrandsAscendingOrder)
    })
    .catch((error) => {
      this.errorMessage = error.response.data.errors
      this.isLoading = false
    })  

    this.selecteduserA = this.invoiceDetails.invoicePercentageData.userA_id;
    this.selecteduserB = this.invoiceDetails.invoicePercentageData.userB_id;
    this.selecteduserC = this.invoiceDetails.invoicePercentageData.userC_id;


  if (! this.invoiceDetails.invoicePercentageData.userB_id)
      {
        document.getElementById('userB_percentage').disabled = true
     }
  if (! this.invoiceDetails.invoicePercentageData.userC_id)
  {     
        // document.getElementById('userC').disabled = true
        document.getElementById('userC_percentage').disabled = true
  }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/EditInvoiceModal.vue